export enum OperatingScopeEnum {
  ORGANIZATION = "ORGANIZATION",
  COMMUNITY = "COMMUNITY"
}
